module.exports = __webpack_public_path__ + "static/img/ex_t5.f1a20bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_t5.jpg
// module id = GFO4
// module chunks = 1